function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.496 14.542L2.936 25.377c-.672.69-1.76.69-2.432 0a1.797 1.797 0 010-2.495l9.344-9.588L.504 3.707a1.798 1.798 0 010-2.495c.671-.69 1.76-.69 2.432 0l10.56 10.835c.336.345.504.796.504 1.247 0 .452-.168.904-.504 1.248z"
})));